(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[3477],{

/***/ 22878:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/changelog",
      function () {
        return __webpack_require__(10866);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 10866:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSG": function() { return /* binding */ __N_SSG; },
  "default": function() { return /* binding */ changelog; }
});

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(34051);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react-datocms/dist/esm/useQuerySubscription/index.js + 2 modules
var useQuerySubscription = __webpack_require__(63430);
// EXTERNAL MODULE: ./node_modules/react-datocms/dist/esm/Seo/renderMetaTags.js
var renderMetaTags = __webpack_require__(12569);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(94184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./node_modules/moment/moment.js
var moment = __webpack_require__(30381);
var moment_default = /*#__PURE__*/__webpack_require__.n(moment);
// EXTERNAL MODULE: ./src/api/index.ts + 5 modules
var api = __webpack_require__(8814);
// EXTERNAL MODULE: ./src/components/index.ts + 103 modules
var components = __webpack_require__(80338);
// EXTERNAL MODULE: ./src/config/index.ts + 4 modules
var config = __webpack_require__(26499);
// EXTERNAL MODULE: ./src/modules/index.ts + 42 modules
var modules = __webpack_require__(88038);
// EXTERNAL MODULE: ./src/utils/index.ts + 7 modules
var utils = __webpack_require__(20978);
// EXTERNAL MODULE: ./node_modules/@narrative-software/narrative-web-ui/dist/index.js
var dist = __webpack_require__(67199);
// EXTERNAL MODULE: ./src/styles/custom.module.css
var custom_module = __webpack_require__(95032);
var custom_module_default = /*#__PURE__*/__webpack_require__.n(custom_module);
;// CONCATENATED MODULE: ./src/components/changelog/ChangelogPage.tsx















var EMOJI_MAP = {
    New: "\uD83D\uDC23",
    Improvements: "\uD83C\uDFCB️‍♀️",
    Fixes: "\uD83D\uDD27"
};
var ChangelogPage = function(param) {
    var preview = param.preview, subscription = param.subscription;
    var data = (0,useQuerySubscription/* useQuerySubscription */.L)(subscription).data;
    if (!data) return null;
    var title = data.title, subheading = data.subheading, releases = data.releases, seo = data.seo;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(components/* Layout */.Ar, {
        preview: preview,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* SEO */.HJ, {
                title: "".concat(title, " | Narrative"),
                children: (0,renderMetaTags/* renderMetaTags */.y)(seo)
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* Section */.$0, {
                isFirstSection: true,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* Container */.W2, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex flex-col items-center text-center",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                                className: "text-h2 font-semibold leading-tight lg:text-h1",
                                children: title
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.HorizontalRule, {
                                topMargin: true,
                                bottomMargin: true
                            }),
                            subheading && /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* HtmlToElement */.Eu, {
                                className: "max-w-200 lg:text-lg",
                                children: subheading
                            })
                        ]
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* Section */.$0, {
                className: "-mt-8 md:-mt-14 lg:-mt-18 xl:-mt-32",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* Container */.W2, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: classnames_default()("grid grid-cols-1 gap-15 lg:gap-22 xl:gap-30", (custom_module_default()).grid),
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* StickySideNav */.bV, {
                                    title: "Releases",
                                    items: releases.map(function(param) {
                                        var id = param.id, version = param.version, date = param.date;
                                        return {
                                            id: id,
                                            title: "v".concat(version, " - ").concat(moment_default()(date).format("D MMMM YYYY"))
                                        };
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                children: releases.map(function(param, i) {
                                    var id = param.id, version = param.version, date = param.date, summary = param.summary, items = param.items;
                                    var title = "v".concat(version, " - ").concat(moment_default()(date).format("D MMMM YYYY"));
                                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("article", {
                                        id: (0,utils/* slugify */.lV)(title),
                                        className: classnames_default()({
                                            "pb-10": i < releases.length - 1
                                        }),
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                                className: "text-h3 font-semibold leading-tight mb-6",
                                                children: title
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* HtmlToElement */.Eu, {
                                                element: "p",
                                                className: "prose text-stealth-bomber leading-relaxed mb-7",
                                                children: summary
                                            }),
                                            items.map(function(param) {
                                                var itemID = param.id, changeType = param.changeType, text = param.text;
                                                return /*#__PURE__*/ (0,jsx_runtime.jsxs)("article", {
                                                    className: "mb-7",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("h4", {
                                                            className: "text-h4 font-semibold leading-tight mb-3",
                                                            children: [
                                                                EMOJI_MAP[changeType],
                                                                "\xa0\xa0",
                                                                changeType
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* HtmlToElement */.Eu, {
                                                            className: "prose text-stealth-bomber leading-relaxed",
                                                            children: text
                                                        })
                                                    ]
                                                }, itemID);
                                            })
                                        ]
                                    }, id);
                                })
                            })
                        ]
                    })
                })
            })
        ]
    });
};
/**
 * Static props
 */ var getStaticProps = function(product) {
    return function() {
        var _ref = _async_to_generator(regeneratorRuntime.mark(function _callee(param) {
            var params, _preview, preview, graphqlRequest, ref, _data, pages, initialData;
            return regeneratorRuntime.wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        params = param.params, _preview = param.preview, preview = _preview === void 0 ? false : _preview;
                        graphqlRequest = {
                            preview: preview,
                            variables: {
                                slug: params === null || params === void 0 ? void 0 : params.slug
                            },
                            query: "\n      {\n        pages: allPageChangelogs {\n          title\n          subheading\n          slug\n          parentPage {\n            ... on ".concat(PAGE_RECORDS.select, " {\n              slug\n            }\n            ... on ").concat(PAGE_RECORDS.publish, " {\n              slug\n            }\n          }\n          releases {\n            id\n            version\n            date\n            summary\n            items {\n              id\n              changeType\n              text\n            }\n          }\n          seo: _seoMetaTags {\n            ...metaTagsFragment\n          }\n        }\n      }\n      ").concat(metaTagsFragment, "\n    ")
                        };
                        _ctx.next = 4;
                        return Api.datocmsGraphqlRequest(graphqlRequest);
                    case 4:
                        ref = _ctx.sent;
                        _data = ref.data;
                        pages = _data.data.pages;
                        initialData = pages.find(function(param) {
                            var parentPage = param.parentPage;
                            return parentPage.slug === product;
                        });
                        initialData === null || initialData === void 0 ? void 0 : initialData.releases.reverse();
                        return _ctx.abrupt("return", {
                            props: {
                                product: product,
                                preview: preview,
                                subscription: preview ? _object_spread_props(_object_spread({}, graphqlRequest), {
                                    initialData: initialData,
                                    token: DATOCMS_API_TOKEN
                                }) : {
                                    initialData: initialData,
                                    enabled: false
                                }
                            }
                        });
                    case 10:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function(_) {
            return _ref.apply(this, arguments);
        };
    }();
};

;// CONCATENATED MODULE: ./src/pages/changelog.tsx

var __N_SSG = true;
/* harmony default export */ var changelog = (ChangelogPage);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [9774,2888,179], function() { return __webpack_exec__(22878); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);